/**
 * Soft reset for the preview demo session.
 * Clears non-persona state; keeps active persona selection.
 */
import { phase1Personas } from "@petci/fixtures";
import { useDemoSessionStore } from "@petci/shared-ui";

export function resetDemoSession(): void {
  useDemoSessionStore.getState().resetSession();

  if (typeof window !== "undefined") {
    for (const persona of phase1Personas) {
      try {
        window.localStorage.removeItem(`petci_hurricane_prep_${persona.id}`);
      } catch {
        // localStorage may be unavailable
      }
    }
  }
}
